import { FormHelperText, TextField, Typography, TypographyProps } from '@mui/material'
import { default as Mui5Slider } from '@mui/material/Slider'
import { styled } from '../../styles'
import { BaseThemeType } from '../../theme'

const body3Styles = {
  fontSize: 12,
  lineHeight: '16px',
  fontWeight: 400,
  letterSpacing: 0,
}

export const StyledTextField = styled(TextField)(({ theme }: { theme: BaseThemeType }) => ({
  width: 38,
  '.Mui-error': {
    color: theme.palette.red[800],
    '.OSUI-OutlinedInput-notchedOutline': {
      borderColor: theme.palette.red[800],
    },
  },

  '.OSUI-InputBase-input': {
    height: 24,
    padding: '2px 8px',
    textAlign: 'center',
    // ...theme.typography.body3, // # TODO use typography from themes, instead of body3Styles
    ...body3Styles,
    backgroundColor: theme.palette.neutralGrey[100],

    borderRadius: 8,
    [theme.breakpoints.down('md')]: {
      borderRadius: 6,
    },
  },
  'input[type=number]': {
    appearance: 'textfield',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      appearance: 'none',
    },
  },
  '.OSUI-OutlinedInput-notchedOutline': {
    boxShadow: 'none',
    borderColor: theme.palette.neutralGrey[500],
  },
}))

export const StyledMui5Slider = styled(Mui5Slider)(({ theme }: { theme: BaseThemeType }) => ({
  minWidth: '320px',
  maxWidth: '540px',
  [theme.breakpoints.between('xl', 'lg')]: {
    minWidth: '280px',
    maxWidth: '480px',
  },
  [theme.breakpoints.between('lg', 'md')]: {
    minWidth: '260px',
    maxWidth: '340px',
  },
  [theme.breakpoints.down('md')]: {
    minWidth: '240px',
    maxWidth: '320px',
  },
}))

interface TypographyAddedProps extends TypographyProps {
  disabled?: boolean
}

export const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<TypographyAddedProps>(({ disabled, theme }: { disabled?: boolean; theme: BaseThemeType }) => ({
  // ...theme.typography.body3, // # TODO use typography from themes, instead of body3Styles
  ...body3Styles,
  color: disabled ? theme.palette.neutralGrey[600] : theme.palette.neutralGrey[900],
}))

export const StyledFormHelperText = styled(FormHelperText)({
  margin: 0,
})
